import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2196F3',
        secondary: '#1976D2',
        accent: '#2196F3',
        error: '#b71c1c'
      }
    }
  }
})

export default vuetify
